import { motion } from "framer-motion";
import { Heart, Sparkles, Users } from "lucide-react";
import { images } from "../../data";

const values = [
  {
    icon: Heart,
    title: "Accoglienza sincera",
    desc: "La titolare ti accoglie con il sorriso e ti consiglia senza fretta, come si faceva una volta.",
  },
  {
    icon: Sparkles,
    title: "Qualità per tutte le tasche",
    desc: "Prodotti curati e resistenti, a prezzi onesti. Il risparmio non sacrifica mai la qualità.",
  },
  {
    icon: Users,
    title: "Per tutta la famiglia",
    desc: "Un assortimento pensato per ogni età e ogni corporatura, con ampia scelta di taglie comode.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="relative order-2 lg:order-1"
        >
          <div className="rounded-2xl overflow-hidden border border-black/5 shadow-[0_20px_60px_rgba(45,40,37,0.12)]">
            <img
              src={images.facciata}
              alt="Facciata del negozio La casa del pigiama a Novara, Via XX Settembre 8"
              className="w-full h-[420px] md:h-[540px] object-cover"
            />
          </div>
          <div className="absolute -top-5 -right-5 hidden sm:block bg-[#123D5B] text-white rounded-xl px-5 py-4 shadow-lg">
            <p className="font-serif text-xl leading-none">Novara</p>
            <p className="text-[10px] tracking-[0.2em] uppercase mt-1 text-white/80">
              Via XX Settembre 8
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="order-1 lg:order-2"
        >
          <div className="text-xs tracking-[0.2em] uppercase text-[#C24E77] mb-6">
            Chi siamo
          </div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#123D5B] leading-tight">
            Un negozio storico,
            <br />
            <span className="italic text-[#C24E77]">un'amica di famiglia.</span>
          </h2>
          <p className="mt-7 text-base md:text-lg text-[#4A5863] leading-relaxed">
            <strong className="font-500 text-[#123D5B]">La casa del pigiama</strong> è
            il punto di riferimento di Novara per l'abbigliamento notte. Uno
            spazio raccolto ma ricchissimo, dove ogni cliente trova ascolto,
            consiglio e la pazienza di chi ama il proprio lavoro.
          </p>
          <p className="mt-4 text-base md:text-lg text-[#4A5863] leading-relaxed">
            Pigiami, camicie da notte, vestaglie e intimo: per tutte le età e
            per tutte le tasche, con un'attenzione speciale alle taglie comode.
          </p>

          <div className="mt-10 grid gap-6">
            {values.map((v) => (
              <div key={v.title} className="flex gap-4">
                <div className="shrink-0 w-11 h-11 rounded-full bg-[#FBEFF3] border border-[#C24E77]/15 flex items-center justify-center">
                  <v.icon size={19} className="text-[#C24E77]" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="font-serif text-xl text-[#123D5B]">{v.title}</h3>
                  <p className="text-sm text-[#4A5863] mt-1 leading-relaxed">
                    {v.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
